export default __webpack_public_path__ + "static/media/surfing.8dbd1f03.png";